import styled from "styled-components";
import { colors } from "@mui/material";

export const TemplateListWrapper = styled.div`
	display: flex;
	flex-flow: row wrap;
	.template {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		margin: 15px;
		position: relative;
		width: 290px;
		min-width: 290px;
		cursor: pointer;
		text-decoration: none;
		color: ${({ theme }) => theme.palette.text.primary};

		.thumbnail {
			width: inherit;
			min-height: 275px;
		}
		.payed {
			position: absolute;
			top: 10px;
			right: 10px;
			width: 25px;
			height: 25px;
			padding: 5px;
			background: #ffffff;
			border: 1px solid #eeee;
			border-radius: 50%;
		}
		.lock-icon {
			position: absolute;
			top: 10px;
			left: 10px;
			color: ${colors.common.white};
			padding: 5px;
			background: ${({ theme }) => theme.custom_palette.color1};
			border-radius: 50%;
			//font-size: 18px;
			width: 30px;
			height: 30px;
		}
	}

	${props => props.theme.breakpoints.down("sm")} {
		justify-content: center;

		.template {
			width: 95%;
			min-width: 95%;
			margin: 15px 0;
			.thumbnail {
				width: 100%;
				//height: 500px;
			}
			.coming_soon_over_lay {
				width: 100%;
				//height: 500px;
			}
		}
	}
`;
